module.exports = __webpack_public_path__ + "img/1_14.b2117d0a.jpg";